(function () {
    'use strict';

    function initSliderPeopleQuotes() {
        if (typeof Swiper === 'undefined') {
            return;
        }

        document.querySelectorAll('.section.section--slider-people-quotes .slider-people-quotes-swiper').forEach(function (swiperEl) {
            var section = swiperEl.closest('.section.section--slider-people-quotes');
            if (!section) {
                return;
            }

            var paginationEl = section.querySelector('.slider-people-quotes-pagination .swiper-pagination');
            var nextEl = section.querySelector('.slider-people-quotes-pagination .swiper-button-next');
            var prevEl = section.querySelector('.slider-people-quotes-pagination .swiper-button-prev');

            var config = {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 24,
                slidesPerGroup: 1,
                speed: 700,
                centeredSlides: false,
                breakpoints: {
                    0: { slidesPerView: 'auto' },
                    576: { slidesPerView: 'auto' },
                    992: { slidesPerView: 'auto' },
                },
            };

            if (paginationEl) {
                config.pagination = { el: paginationEl, clickable: true };
            }
            if (nextEl && prevEl) {
                config.navigation = { nextEl: nextEl, prevEl: prevEl };
            }

            new Swiper(swiperEl, config);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSliderPeopleQuotes);
    } else {
        initSliderPeopleQuotes();
    }
})();
